import Layout from '@/components/Layout';
import Category from '@/components/Category';
import API from '../../../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '@/components/Category/category.module.scss';

// Заглушка для переводов
const translate = s => s;

const Catalog = ({ data }) => {
  return <Category data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Категории'), route: '/catalog' },
];

Catalog.getLayout = (page, t) => {
  return (
    <Layout
      page={page.props}
      title={`${
        page.props.data?.title ? page.props.data.title : t(`Каталог продукции`)
      } — UNIFROST`}
      breadcrumbs={[
        ...breadcrumbs,
        { title: page.props.data.title, route: `/catalog/category/${page.props.data.id}` },
      ]}
      paddings={false}
      customPaddings={styles.paddings}
    >
      {page}
    </Layout>
  );
};

export async function getServerSideProps(context) {
  const props = { data: {} };
  const status = 200;

  if (context.params.id) {
    try {
      const res = await API.get(`/v1/api/products/category/${context.params.id}/`, {
        headers: { 'Accept-Language': context.locale },
      });

      if (res.status === 200) {
        if (res.data.id) props.data = res.data;
      }
    } catch (error) {
      return { notFound: true };
    }

    try {
      const resCategories = await API.get(`/v1/api/products/categories/`, {
        headers: { 'Accept-Language': context.locale },
      });

      if (resCategories.status === 200 && Array.isArray(resCategories.data)) {
        if (resCategories.data) props.data.categories = resCategories.data;
      }
    } catch (error) {}

    try {
      const res = await API.get(`/v1/api/pages/catalog/`, {
        headers: { 'Accept-Language': context.locale },
      });

      if (res.status === 200) {
        if (res.data) {
          props.data.title = res.data.title;
          props.data.text = res.data.text;
        }
      }
    } catch (error) {}
  } else {
    return { notFound: true };
  }

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu', 'products'])),
    },
    // revalidate: 60,
  };
}

export const getServerSidePaths = async ({ locales }) => {
  const resCategories = await API.get(`/v1/api/products/categories/`);
  const paths = [];
  const plainPaths = resCategories.data
    .map(({ products }) => products)
    .reduce(
      (acc, curr) => [...acc, ...curr.map(({ id }) => ({ params: { id: id.toString() } }))],
      []
    );

  for (const locale of locales) {
    for (const path of plainPaths) {
      paths.push(path);
      paths.push({ ...path, locale });
    }
  }
  return {
    paths,
    fallback: 'blocking',
  };
};

export default Catalog;
